<template>
	<div class="pages fx content">
		<section class="phone-show fx-shrink">
			<h3>会员卡</h3>
			<div class="card">
				<div class="card-cont">
					<div class="fx">
						<div class="fx fx-y-center fx-fill">
							<div class="logo-pic"><img :src="logo" /></div>
							<div class="m-l-10 card-name">
								<p class="text-ellipsis w120">{{userInfo.username || '请完善商户名称'}}</p>
								<p class="m-t-5">{{params.title}}</p>
							</div>
						</div>
						<div class="icon-code-simple fx-shrink"></div>
					</div>
					<div class="card-num">1234 5678 9101</div>
				</div>
				<div class="card-pic"><img :src="params.face"/></div>
			</div>
			<div class="card-info">
				<ul class="fx fx-y-center">
					<li class="fx-fill">
						<h4>积分</h4>
						<p>0</p>
					</li>
					<li class="fx-fill">
						<h4>折扣</h4>
						<p>{{params.discount | formatDscount}}</p>
					</li>
				</ul>
			</div>
			<div class="card-menu">
				<ul class="fx">
					<li class="fx-fill">
						<div class="fx-align"><i class="icon-vipcard"></i></div>
						<p>会员卡详情</p>
					</li>
					<li class="fx-fill">
						<div class="fx-align"><i class="icon-store"></i></div>
						<p>适用门店</p>
					</li>
					<li class="fx-fill" >
						<div class="fx-align"><i class="icon-info-edit"></i></div>
						<p>个人资料</p>
					</li>
					<li class="fx-fill">
						<div class="fx-align"><i class="icon-coupon"></i></div>
						<p>优惠券</p>
					</li>
				</ul>
			</div>
		</section>
		<section class="menu-edit b-r-5 fx-fill">
			<!--<div class="fx fx-y-center">
				<div class="w80 m-r-5">商户名称：</div>
				<div class="fx-fill">皮休管家</div>
			</div>-->
			<!--<div class="fx fx-y-center m-t-15">
				<p class="fx w80 m-r-5"><span class="fx-fill">商户logo：</span><i class="ask">*</i></p>
				<div>
					<div v-show="isDisabled" class="question-api">
						<input @change="handleFile" id="file" type="file" name="file" multiple>
						<img :src="this.params.face" />
						<div class="edit fx-align"><span class="icon icon-edit"></span></div>
					</div>
					<div class="file-btn" v-show="!params.face && !isDisabled">
						<input @change="handleFile" id="files" type="file" name="file" multiple>
						<a class="z-btn z-btn-primary b-r-3">上传</a>
					</div>
				</div>
				<div class="pic-tips m-l-10">建议尺寸：200*200</div>
			</div>-->
			<div class="m-b-20" v-if="params.id">
				<div class="fx fx-y-center">
					<div class="title fx w120 m-r-5">
						<p class="ask-cont"></p>
						<span>前台地址</span>
					</div>
					<div class="fx-fill">https://open.pixiugj.com/vip_card?mid={{userInfo.mid}}&scope=snsapi_userinfo</div>
				</div>
			</div>
			<div class="w400"><z-input title="会员卡名称"maxlength="8" isMust = true placeholder="会员卡名称最多8个字" v-model="params.title"></z-input></div>
			<div class="fx m-t-20">
				<div class="w120 fx-shrink m-r-5 m-t-5 fx"><i class="ask">*</i><span class="fx-fill">会员卡封面</span></div>
				<div class="card-bg fx-fill">
					<ul class="fx fx-wrap">
						<li v-for="item in face_list" :class="{'active': params.face == item.url}" @click="handleChooseFace(item)"><img :src="item.url"/></li>
					</ul>
				</div>
			</div>
			<div class="w400 m-t-15">
				<div class="fx fx-y-center ">
					<z-input title="会员折扣" isMust = true placeholder="例：95折输入95" v-model="params.discount" type="number"></z-input>
					<p class="m-l-5">折</p>
				</div>
				<div class="fx m-t-5">
					<p class="w120 fx-shrink m-r-5"></p>
					<p class="pic-tips">Tips：折扣值必须是1-99的整数</p>
				</div>
			</div>
			<section class="integral-cont">
				<div class="fx m-t-20">
					<div class="w120 fx-shrink m-r-5 m-t-5 fx"><i class="ask">*</i><span class="fx-fill">积分规则</span></div>
					<div>
						每消费 <input type="text" name="" id="" v-model="params.cost_money_unit" class="m-r-5 m-l-5 b-r-5 input-money" />元，
						增加<input type="text" name="" id="" value="" v-model="params.increase_bonus" class="input-money m-r-5 m-l-5 b-r-5" />积分
					</div>
				</div>
			</section>
			<div class=" m-t-20"><z-input title="使用说明" type="textarea" v-model="params.description" isMust = true placeholder="上面会员权益如已经填写“会员折扣”“会员积分”的内容，将会在会员卡详情展示，无需重复填写。“使用说明”可以填写其他会员特权，例如：100积分可以抵扣1元现金；积分可以参与抽奖、实物兑换等。"></z-input></div>
			<div class="w400 m-t-20"><z-input type="tel" title="客服电话" placeholder="请填写客服手机号" v-model="params.service_phone" maxlength = 11></z-input></div>
			<div class="fx m-t-20">
				<p class="w120 fx-shrink fx"><i class="ask">*</i><span class="fx-fill">会员卡状态</span></p>
				<div class="fx-fill m-l-5">
					<div class="fx">
						<label class="fx fx-y-center m-r-20">
							<input type="radio" name="switch" id="" @click="handleStatus" value="" :checked="params.status==1 ? true : false" class="radio m-r-5 b-r-50"/>
							<span>开启</span>
						</label>
						<label class="fx fx-y-center">
							<input type="radio" name="switch" id="" @click="handleStatus" value="" :checked="params.status==0 ? true : false" class="radio m-r-5 b-r-50"/>
							<span>关闭</span>
						</label>
					</div>
					<p class="m-t-5 c-g">Tips：会员卡状态为关闭时，停止所有用户使用，并停止领取。</p>
				</div>
			</div>
			<div class="m-t-20 fx">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleCreateMemberCard">保存</a>
			</div>
		</section>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex'
	import logo from '@/assets/img/logo.png'
	export default {
		name: 'VipManage',
		data() {
			return {
				logo,
				url: '',
				params: {
					id: '',
					title: '',
					discount: '',
					description: '',
					service_phone: '',
					status: 1,
					card_id: '',
					cost_money_unit: 1,
					increase_bonus: 1,
//					type: 'base',
					face: '',
					logo_url: '',
				},
				face_list: [{
					url: "https://pixiugj.oss-cn-hangzhou.aliyuncs.com/mp_pixiugj/uploads/1498811148218.png",
					wurl: "http://mmbiz.qpic.cn/mmbiz_png/DA3lMpC0v8rYvL7g7VCdrWnjX9OZZkGjdorLmOXuZuxV9JJykictmibBc13VHgsZtvroHZOgI9FSKagTu9f9BXkg/0?wx_fmt=png"
				}, {
					url: "https://pixiugj.oss-cn-hangzhou.aliyuncs.com/mp_pixiugj/uploads/1498811260624.png",
					wurl: "http://mmbiz.qpic.cn/mmbiz_png/DA3lMpC0v8rYvL7g7VCdrWnjX9OZZkGjdCkHmgjRwib2DcAQqyJoniaibgWJBTwSOJKcTOtFkeR1fDupJu0QAaPOw/0?wx_fmt=png"
				}, {
					url: "https://pixiugj.oss-cn-hangzhou.aliyuncs.com/mp_pixiugj/uploads/1498811202434.png",
					wurl: "http://mmbiz.qpic.cn/mmbiz_png/DA3lMpC0v8rYvL7g7VCdrWnjX9OZZkGjvC1elaFpuzBO4IquydWNWq1WGcBS8mH27rxJdOtwo0kpoibF1cEiahJg/0?wx_fmt=png"
				}, {
					url: "https://pixiugj.oss-cn-hangzhou.aliyuncs.com/mp_pixiugj/uploads/1498811091271.png",
					wurl: "http://mmbiz.qpic.cn/mmbiz_png/DA3lMpC0v8rYvL7g7VCdrWnjX9OZZkGjbC1R6lFEiaycicTILsYVpQiceqCrUgIUYdxicibrxbP2qh3ES3mlDozugLg/0?wx_fmt=png"
				}, {
					url: "https://pixiugj.oss-cn-hangzhou.aliyuncs.com/mp_pixiugj/uploads/1498811219756.png",
					wurl: "http://mmbiz.qpic.cn/mmbiz_png/DA3lMpC0v8rYvL7g7VCdrWnjX9OZZkGjaLc74iaEHJAzyH9eib03W3YRovVuk79jcjjicxYyXvt8o0DBMDVZzOElA/0?wx_fmt=png"
				}, {
					url: "https://pixiugj.oss-cn-hangzhou.aliyuncs.com/mp_pixiugj/uploads/1498811248095.png",
					wurl: "http://mmbiz.qpic.cn/mmbiz_png/DA3lMpC0v8rYvL7g7VCdrWnjX9OZZkGj9FtBBNwKoNBoBFSiaLpKAEibAh3Acg17JL3XLDuVRExgJ6cgopO6kG6w/0?wx_fmt=png"
				}, {
					url: "https://pixiugj.oss-cn-hangzhou.aliyuncs.com/mp_pixiugj/uploads/1498811174785.png",
					wurl: "http://mmbiz.qpic.cn/mmbiz_png/DA3lMpC0v8rYvL7g7VCdrWnjX9OZZkGjbdkibnGb9T6WUtgyxP2noYE98ktKeXY65md8v3h7ib5zpzrLUffhqXKQ/0?wx_fmt=png"
				}, {
					url: "https://pixiugj.oss-cn-hangzhou.aliyuncs.com/mp_pixiugj/uploads/1498811233320.png",
					wurl: "http://mmbiz.qpic.cn/mmbiz_png/DA3lMpC0v8rYvL7g7VCdrWnjX9OZZkGjmlIMxMJXAChTF9LOJqDxLkm3K97qtKZPLAibIOZWmbsVo3lubjFNZ4Q/0?wx_fmt=png"
				}],
			}
		},
		computed: {
			...mapState({
				userInfo: state => state.users.userInfo,
				cardInfo: state => state.vipCard.cardInfo
			})
		},
		mounted() {
			this.handleVipCardInfo();
		},
		/*
		 * 事件处理
		 */
		methods: {
			//获取会员卡详情
			async handleVipCardInfo() {
				await this.getVipCardInfo();
				if (this.cardInfo) {
					this.params = this.cardInfo;
					this.params.cost_money_unit = this.params.cost_money_unit / 100;
					this.params.type = 'base';
				} else {
					//默认选中第一张封面
					this.params.face = this.face_list[0].url;
				}
			},
			
			//选择封面
			handleChooseFace(face) {
				this.params.face = face.url;
				this.params.logo_url = face.url;
			},
			
			//选择状态
			handleStatus() {
				this.params.status = this.params.status == 1 ? 0 : 1;
			},
			
			//创建会员卡
			async handleCreateMemberCard() {
				if (!this.params.title) return this.$warning('请输入会员卡名称');
				if (!this.params.face) return this.$warning('请选择会员卡封面');
				if (!this.params.discount) return this.$warning('请输入折扣值');
				if (this.params.discount && (this.params.discount <= 0 || this.params.discount >= 100)) return this.$warning('折扣值必须是1-99的整数');
				if (!this.$re_twoPoint(this.params.cost_money_unit)) return this.$warning('请输入合法的消费金额,最多两位小数');
				if (!this.$re_Number(this.params.increase_bonus)) return this.$warning('请输入合法的积分值');				
				if (this.params.service_phone && !this.$re_phone(this.params.service_phone)) return this.$warning('请输入合法的手机号');
				if (!this.params.description) return this.$warning('请输入会员卡使用说明');
				let parmas = Object.assign({},this.params);
				parmas.cost_money_unit = parmas.cost_money_unit * 100;
				parmas.discount = parmas.discount+'';
				parmas.mid = this.userInfo.mid;
				console.log('----params---', parmas);
				await this.saveVipCard(parmas);
				this.handleVipCardInfo()
				this.$success('操作成功');
			},
			
			...mapActions(['getVipCardInfo', 'saveVipCard']),
		}
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.c-g{
		color: $color-font-tips;
	}
	.phone-show {
		width: 350px;
		height: 716px;
		background: url(../../../assets/img/iphone.png) no-repeat;
		background-size: 100% auto;
		padding: 160px 24px 120px 24px;
		position: relative;
		h3 {
			width: 304px;
			position: absolute;
			top: 91px;
			left: 50%;
			background: #363535;
			color: #fff;
			text-align: center;
			padding: 15px 0;
			margin-left: -152px;
			font-size: 16px;
		}
		.card {
			border-radius: 20px;
			margin: 0 10px;
			position: relative;
			padding: 20px 15px;
			.logo-pic {
				width: 50px;
				height: 50px;
				border-radius: 50%;
				border: 1px solid $color-border;
				background: #fff;
				overflow: hidden;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.card-name,
			.icon-code-simple {
				color: #fff;
			}
			.icon-code-simple {
				font-size: 40px;
			}
			.card-num {
				color: #fff;
				padding-top: 70px;
				font-size: 16px;
			}
			.card-cont{
				position: relative;
				z-index: 4;
			}
			.card-pic{
				position: absolute;
				top: 0;
				left: 0;
				img{
					width: 100%;
				}
			}
		}
		.card-info {
			padding: 20px 0;
			li {
				text-align: center;
				+li {
					border-left: 1px solid $color-border;
				}
				h4 {
					color: $color-7a7a7a;
					padding-bottom: 5px;
				}
				p {
					color: $color-main;
				}
			}
		}
		.card-menu {
			margin-top: px-em(40px);
			li {
				i{
					font-size: px-em(40px);
					color: $color-font-sub;
				}
				p{
					margin-top: px-em(30px);
					text-align: center;
					color: $color-font-sub;
				}

			}
		}
	}
	
	.integral-cont{
		h3{
			background: #eee;
			padding: 5px 10px;
		}
		.input-money{
			width: px-em(200px);
			border: 1px solid $color-border;
			padding: px-em(16px) px-em(20px);
		}
	}
	
	.menu-edit {
		border: 1px solid $color-border;
		padding: 20px;
		position: relative;
		margin-left: 30px;
		&:after,
		&:before {
			right: 100%;
			top: 15%;
			border: solid transparent;
			content: " ";
			height: 0;
			width: 0;
			position: absolute;
			pointer-events: none;
		}
		&:after {
			border-color: rgba($color-border, 0);
			border-right-color: #fff;
			border-width: 20px;
			margin-top: -20px;
		}
		&:before {
			border-color: rgba($color-border, 0);
			border-right-color: #ccc;
			border-width: 21px;
			margin-top: -21px;
		}
		.card-bg{
			li{
				width: 60px;
				height: 37px;
				cursor: pointer;
				transition: all 0.2s ease;
				border: 1px solid transparent;
				margin-right: 5px;
				margin-bottom: 5px;
				border-radius: 3px;
				img{
					width: 100%;
					border-radius: 3px;
				}
				&.active{
					border-color: $color-main;
					position: relative;
					@extend .icon;
				    &:before {
				        content: "\e63f";
				        position: absolute;
				        left: 50%;
				        top: 50%;
				        margin: px-em(-26px) 0 0 px-em(-26px);
				        font-size: px-em(52px);
				        color: $color-white;
				    }
				}
				&:hover{
					border-color: $color-main;
				}
				&:active{
					transform: scale(0.9);
				}
			}
		}
		.vip-droit{
			input[type="text"]{
				width: 140px;
			}
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1100px);
		}
		.phone-show{
			display: none;
		}
		.menu-edit{
			border: none;
			margin: 0;
			padding: 0;
			&:before{
				display: none;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// VipManage.vue?5327bb29